module.exports = __webpack_public_path__ + "static/media/notification_bell.8410fb02.svg";